<a class="link-color" (click) = redirectToDetail()
   particleAnalytics
   analyticsCategory= "email-cell-viewer"
   analyticsAction= "email"
   [analyticsName]="item.cells[fieldDefinition.key]?.displayText">
  {{ item.cells[fieldDefinition.key]?.displayText }}
</a>
